<template>
    <font-awesome-icon icon="edit" size="lg" class="icon-button" title="Atualizar" v-if="$temAcessoView('RM-CONV-EXEC-DIRETA-06')" />
</template>